import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import 'rxjs';
import { AlertService } from '../../../providers/alert-service';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { ContasBancariasService } from '../../../providers/contas-bancarias-service';

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

//import { FileService } from '../../../providers/file-service';

@Component({
  selector: 'page-modal-contas-bancarias',
  templateUrl: 'modal-contas-bancarias.html'
})

export class ModalContasBancariasPage {
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

  objetoBanco: any = null;
  objetoConta: any = null;
  objetoContaVinculada: any = null;
  objetoFonteDiferenca: any = null;
  isJurisdicionado: any;
  isCGE: any;
  isSefaz: any;
  acao: any;
  listaVinculada: any[];

  vinculadaDisabled: any = true;

  diff: any;
  saldoDiferenca: any = 0;
  saldoExtrato: any = 0;
  saldoS2GPR: any = 0;
  listaTipoContas: any = [];
  listaBancos: any = [];
  listaDiferencas: any = [];

  listaContasCadastradas: any = [];

  myDatePickerRegistroDifOptions: IMyDpOptions;

  numberMask = createNumberMask({
    prefix: '',
    suffix: '', // This will put the dollar sign at the end, with a space.
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: '.',
    allowDecimal: false,
    decimalSymbol: ','
  });

  contaBancariaFDifAdicionar: any = {
    "idFonteDiferenca": "",
    "dsFonteDiferenca": "",
    "idDiferenca": "",
    "data": "",
    "justificativa": "",
    "valor": ""
  }

  //placefolder da data da diferencia
  private placeholder: string = 'Data'

  analise: any = null;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;
  
  //Construtor da Página
  constructor(

    public contasBancariasService: ContasBancariasService,
    private alertService: AlertService,
    //private fileService: FileService,

    private viewCtrl: ViewController,
    public navParams: NavParams,

    public gestaoPcaService: GestaoPcaService) {

    this.myDatePickerRegistroDifOptions = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      openSelectorTopOfInput: true,
      showClearDateBtn: false,
      showSelectorArrow: false
    };


    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.acao = this.navParams.get('acao');

    this.analise = this.navParams.get('analise');

    this.isSefaz = this.navParams.get('isSefaz');

    this.objetoConta = this.navParams.get('objetoConta')

    this.carregarModal();
  }

  //placeholder da data da diferen~ca
  changePlaceholder() {
    this.placeholder = 'Data';
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  carregarModal() {
    this.carregarTipoContas();
    this.carregarListaBancos();
    this.carregarListaDiferencas();
  }

  somarValorDasDiferencas() {
    let total: any = 0;
    let diff: any = 0;

    this.objetoConta.diferencas.forEach(diferenca => {

      if (diferenca.valor == "" || diferenca.valor == null || diferenca.valor == undefined || isNaN(diferenca.valor)) {
        diff = 0;
      } else {
        diff = diferenca.valor;
      }

      total += parseFloat(diff)
    })

    if (this.objetoConta.diferencas != undefined) {
      return total
    }
    else {
      return 0
    }
  };

  calcularDiferenca() {

    if (this.objetoConta.saldoS2GPR == "" || this.objetoConta.saldoS2GPR == null || this.objetoConta.saldoS2GPR == undefined || isNaN(this.objetoConta.saldoS2GPR)) {
      this.saldoS2GPR = 0;
    } else {
      this.saldoS2GPR = this.objetoConta.saldoS2GPR;
    }

    if (this.objetoConta.saldoExtrato == "" || this.objetoConta.saldoExtrato == null || this.objetoConta.saldoExtrato == undefined || isNaN(this.objetoConta.saldoS2GPR)) {
      this.saldoExtrato = 0;
    } else {
      this.saldoExtrato = this.objetoConta.saldoExtrato;
    }

    this.saldoDiferenca = parseFloat(this.saldoExtrato) - parseFloat(this.saldoS2GPR) - parseFloat(this.somarValorDasDiferencas());

    return this.saldoDiferenca;
  }

  adicionarFD() {

    if(!this.objetoFonteDiferenca){
      this.alertService.mostraAlerta("", "Selecione a Fonte de Diferença.");
      return;
    }

    let FDNova = {
      "idFonteDiferenca": this.contaBancariaFDifAdicionar.idFonteDiferenca,
      "dsFonteDiferenca": this.contaBancariaFDifAdicionar.dsFonteDiferenca,
      "idDiferenca": "0",
      "data": this.contaBancariaFDifAdicionar.data,
      "justificativa": this.contaBancariaFDifAdicionar.justificativa,
      "valor": this.contaBancariaFDifAdicionar.valor
    };

    this.objetoConta.diferencas.push(FDNova);

    this.contaBancariaFDifAdicionar.idFonteDiferenca = 0;
    this.contaBancariaFDifAdicionar.dsFonteDiferenca = "";
    this.contaBancariaFDifAdicionar.idDiferenca = 0;
    this.contaBancariaFDifAdicionar.data = null;
    this.contaBancariaFDifAdicionar.justificativa = "";
    this.contaBancariaFDifAdicionar.valor = 0;

  };

  carregarTipoContas() {
    this.contasBancariasService.listarTiposConta().subscribe(data => this.listaTipoContas = data, error => console.log("erro: " + error));
  }


  carregarListaBancos() {
    this.contasBancariasService.listarBancos().subscribe(data => {
      this.listaBancos = data;

      this.objetoBanco = this.listaBancos.filter((banco) => this.objetoConta.idBanco == banco.id)[0];

      if (this.objetoBanco != undefined || this.objetoBanco != null) {
        this.contasBancariasService.listarContasPorBanco(this.objetoBanco.codigo).subscribe(data => {
          this.listaVinculada = data;

          this.objetoContaVinculada = this.listaVinculada.filter((vinc) => this.objetoConta.dsVinculada == vinc.dsAgencia + " - " + vinc.numeroConta)[0];
        });
      }

    }, error => {
      console.log("erro: " + error);
    });
  }

  carregarListaDiferencas() {
    this.contasBancariasService.listarDiferencas().subscribe(data => this.listaDiferencas = data, error => console.log("erro: " + error));

  }

  onTipoContaChange(novoValor) {
    this.objetoConta.idTipoConta = novoValor;
  }

  onBancoChange(novoValor) {
    this.objetoConta.idBanco = novoValor.id;

    this.contasBancariasService.listarContasPorBanco(novoValor.codigo).subscribe(data => {
      this.listaVinculada = data;

      if (data.length > 0) {
        this.vinculadaDisabled = false;
      }
    }, error => {
      console.log("erro: " + error);
    });
  }

  onVinculadaChange(novoValor) {
    this.objetoConta.dsVinculada = novoValor.dsAgencia + " - " + novoValor.numeroConta;
  }

  onDiferencaChange(novoValor) {
    this.contaBancariaFDifAdicionar.idFonteDiferenca = novoValor.id;
    this.contaBancariaFDifAdicionar.dsFonteDiferenca = novoValor.dsFonteDiferenca;
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  onDataRegistroDifChanged(event: IMyDateModel) {
    if (event.jsdate === null) {
      this.contaBancariaFDifAdicionar.data = null;
    }
    else {
      this.contaBancariaFDifAdicionar.data = new Date(event.jsdate).toLocaleDateString('pt-br');
    }
  }

  salvarConta() {

    if (this.objetoConta.idTipoConta == undefined || this.objetoConta.idTipoConta == "") {
      this.alertService.mostraAlerta("", "Selecione o Tipo da Conta Bancária.");
      return;
    }

    if (this.objetoConta.idBanco == undefined || this.objetoConta.idBanco == "") {
      this.alertService.mostraAlerta("", "Selecione o Banco.");
      return;
    }

    if (this.objetoConta.dsAgencia == undefined || this.objetoConta.dsAgencia == "") {
      this.alertService.mostraAlerta("", "Informe o número da agência bancária.");
      return;
    }

    if (this.objetoConta.numeroConta == undefined || this.objetoConta.numeroConta == "") {
      this.alertService.mostraAlerta("", "Informe o número da conta corrente.");
      return;
    }

    if (this.objetoConta.idPca == undefined || this.objetoConta.idPca == "") {
      this.alertService.mostraAlerta("", "O código da Pca não localizado. Comunique ao administrador.");
      return;
    }

    else {

      // regra de validacao. Se (SIAFE - Extrato) <> Fonte de Diferença. Perguntar se deseja registrar mesmo assim.
      if (this.saldoDiferenca != 0) {

        this.alertService.mostraModalConfirmacao("Importante", "Há diferença entre os valores do extrato e do SIAFE. Deseja cadastrar a conta mesmo assim?", callback => {
          if (callback) {

            this.objetoConta.saldoExtrato = this.saldoExtrato;
            this.objetoConta.saldoS2GPR = this.saldoS2GPR;

            this.objetoConta.saldoExtrato = parseFloat(this.objetoConta.saldoExtrato.toString().trim().replace(',', '.'));
            this.objetoConta.saldoS2GPR = parseFloat(this.objetoConta.saldoS2GPR.toString().trim().replace(',', '.'));
                      
            this.contasBancariasService.salvarNovaConta(this.objetoConta).subscribe(data => {
              this.alertService.mostraAlerta("", "Informações da Conta Bancária atualizadas com sucesso.");
              this.dismiss();
            }, error => {
              this.alertService.mostraAlerta("", "Houve um problema na atualização das informações da conta bancária.");
            });
          }
        })
      }

      // se nao há diferenca com o SIAFE
      else {

        this.objetoConta.saldoExtrato = this.saldoExtrato;
        this.objetoConta.saldoS2GPR = this.saldoS2GPR;

        this.objetoConta.saldoExtrato = parseFloat(this.objetoConta.saldoExtrato.toString().trim().replace(',', '.'));
        this.objetoConta.saldoS2GPR = parseFloat(this.objetoConta.saldoS2GPR.toString().trim().replace(',', '.'));

        this.contasBancariasService.salvarNovaConta(this.objetoConta).subscribe(data => {
          this.alertService.mostraAlerta("", "Informações da Conta Bancária salvas com sucesso.");
          this.dismiss();
        }, error => {
          this.alertService.mostraAlerta("Houve um problema ao salvar a conta bancária.", error.mensagem);
        });
      }
    }
  }

  removerFonteDiferenca(item) {

    this.alertService.mostraModalConfirmacao("Remover Fonte Diferença", "Deseja remover a Fonte da Diferença?", callback => {
      if (callback) {

        let index = this.objetoConta.diferencas.indexOf(item);
        this.objetoConta.diferencas.splice(index, 1);

        if (item.idDiferenca != "0") {
          this.contasBancariasService.removerContaFonteDiferenca(item.idDiferenca).subscribe(data => {
            this.alertService.mostraAlerta("", "Fonte da Diferença removida com sucesso.");
          }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao deletar a Fonte da Diferença:" + error);
          });
        }
      }
    });
  }



  truncateText(text) {
    let numberOfWordsToTruncate = 7;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords = text.toString().split(" ");
    let numberOfWordsToTruncate = 7;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  templateCargaEmMassa() {
    this.contasBancariasService.downloadTemplateContasMassa();
  }

  cargaEmMassa(event) {
    this.alertService.mostraModalConfirmacao("Salvar Contas em Massa", 
      "Você tem certeza que deseja salvar contas em massa?",
      retornoModal => {
        if (retornoModal) {
          this.contasBancariasService.salvarContaEmMassa(event).subscribe(data => {
            this.inputFileCMVar.nativeElement.value = "";
            this.alertService.mostraAlerta("Arquivo carregado.", "Contas bancárias salvas.");
            
            this.carregarModal();
          
          }, error => {
            this.inputFileCMVar.nativeElement.value = "";
            this.alertService.mostraAlerta("Falha ao carregar o arquivo.", error.mensagem);
          });
        } else {
          this.inputFileCMVar.nativeElement.value = "";
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-contas-bancarias/modal-contas-bancarias.ts